import { Res } from 'common/types/responses'
import { service } from 'common/service'

export const forwardingPricesService = service
  .enhanceEndpoints({ addTagTypes: ['ForwardingPrices'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getForwardingPrices: builder.query<Res['forwardingPrices'], void>({
        providesTags: [{ id: 'LIST', type: 'ForwardingPrices' }],
        query: () => ({
          url: `mailbox/forwarding/prices`,
        }),
      }),
      // END OF ENDPOINTS
    }),
  })

// END OF FUNCTION_EXPORTS

export const {
  useGetForwardingPricesQuery,
  // END OF EXPORTS
} = forwardingPricesService

/* Usage examples:
const { data, isLoading } = useGetForwardingPricesQuery()
*/
